////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const rgpd = {
	postSearchCustomer: (customer = {}, queryParams = { page: '0', size: '250', sort: 'saleOrder.createdDate', nameDir: 'desc' }) => ({
		type: ActionsTypes.POST_SEARCH_CUTOMER,
		payload: {
			customer,
			queryParams,
		},
	}),
	postSearchCustomerSuccess: (data) => ({
		type: ActionsTypes.POST_SEARCH_CUTOMER_SUCCESS,
		payload: {
			data,
		},
	}),
	postSearchCustomerFailure: (error) => ({
		type: ActionsTypes.POST_SEARCH_CUTOMER_FAILURE,
		payload: {
			error,
		},
	}),

	postCustomerData: (customer = {}) => ({
		type: ActionsTypes.POST_CUSTOMER_DATA,
		payload: {
			customer,
		},
	}),
	postCustomerDataSuccess: (data) => ({
		type: ActionsTypes.POST_CUSTOMER_DATA_SUCCESS,
		payload: {
			data,
		},
	}),
	postCustomerDataFailure: (error) => ({
		type: ActionsTypes.POST_CUSTOMER_DATA_FAILURE,
		payload: {
			error,
		},
	}),

	postAnonymiseData: (customer = {}) => ({
		type: ActionsTypes.POST_ANONYMISE_DATA,
		payload: {
			customer,
		},
	}),
	postAnonymiseDataSuccess: (data) => ({
		type: ActionsTypes.POST_ANONYMISE_DATA_SUCCESS,
		payload: {
			data,
		},
	}),
	postAnonymiseDataFailure: (error) => ({
		type: ActionsTypes.POST_ANONYMISE_DATA_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataRGPD: () => ({
		type: ActionsTypes.RESET_DATA_RGPD,
	}),
	resetUnknownMailError: () => ({
		type: ActionsTypes.RESET_UNKNOWN_MAIL_ERROR,
	}),
}

export default rgpd
